import { useState } from 'react';
import type { AdminTabId } from '../types';
import { adminTabMeta } from '../types';

interface AdminTopbarProps {
  activeTab: AdminTabId;
}

export default function AdminTopbar({ activeTab }: AdminTopbarProps) {
  const meta = adminTabMeta[activeTab];
  const [notifOpen, setNotifOpen] = useState(false);

  const notifications = [
    { id: 1, icon: 'ri-message-3-line', color: 'text-orange-400', bg: 'bg-orange-500/10', text: 'Petra K. poslala správu', time: 'pred 5 min' },
    { id: 2, icon: 'ri-secure-payment-line', color: 'text-teal-400', bg: 'bg-teal-500/10', text: 'Platba 1 200 € prijatá', time: 'pred 32 min' },
    { id: 3, icon: 'ri-user-add-line', color: 'text-emerald-400', bg: 'bg-emerald-500/10', text: 'Nový klient: TechFlow s.r.o.', time: 'pred 2 hod' },
    { id: 4, icon: 'ri-alarm-warning-line', color: 'text-red-400', bg: 'bg-red-500/10', text: 'Faktúra BOO-2025-018 po splatnosti', time: 'pred 1 dňom' },
  ];

  return (
    <header className="flex-shrink-0 h-16 border-b border-zinc-800 bg-zinc-900/60 backdrop-blur-sm flex items-center px-6 gap-4 relative z-30">
      <div className="flex-1 min-w-0">
        <h1 className="text-white font-bold text-base leading-none">{meta.title}</h1>
        <p className="text-zinc-500 text-xs mt-1">{meta.sub}</p>
      </div>

      <div className="flex items-center gap-3 flex-shrink-0">
        {/* Search */}
        <div className="flex items-center gap-2 bg-zinc-800 border border-zinc-700 rounded-xl px-3 py-2 w-44">
          <i className="ri-search-line text-zinc-500 text-sm" />
          <input
            placeholder="Hľadať..."
            className="bg-transparent text-zinc-300 text-xs placeholder:text-zinc-600 outline-none flex-1 min-w-0"
          />
        </div>

        {/* Add client button */}
        <button className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-xs font-semibold px-3.5 py-2 rounded-xl transition-all cursor-pointer whitespace-nowrap">
          <i className="ri-add-line text-sm" />
          Nový klient
        </button>

        {/* Live */}
        <div className="flex items-center gap-1.5 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-3 py-1.5">
          <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse flex-shrink-0" />
          <span className="text-emerald-400 text-xs font-semibold">Live</span>
        </div>

        {/* Notifications */}
        <div className="relative">
          <button
            onClick={() => setNotifOpen((v) => !v)}
            className="relative w-9 h-9 flex items-center justify-center rounded-xl bg-zinc-800 border border-zinc-700 hover:bg-zinc-700 cursor-pointer transition-all"
          >
            <i className="ri-notification-3-line text-zinc-400 text-base" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-orange-500 rounded-full" />
          </button>

          {notifOpen && (
            <div className="absolute right-0 top-12 w-72 bg-zinc-900 border border-zinc-700 rounded-2xl shadow-2xl overflow-hidden">
              <div className="px-4 py-3 border-b border-zinc-800 flex items-center justify-between">
                <p className="text-white text-sm font-semibold">Notifikácie</p>
                <span className="bg-orange-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">4</span>
              </div>
              <div className="divide-y divide-zinc-800">
                {notifications.map((n) => (
                  <div key={n.id} className="flex items-start gap-3 px-4 py-3 hover:bg-zinc-800/50 cursor-pointer transition-all">
                    <div className={`w-8 h-8 rounded-lg ${n.bg} flex items-center justify-center flex-shrink-0`}>
                      <i className={`${n.icon} ${n.color} text-sm`} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-zinc-200 text-xs font-medium leading-snug">{n.text}</p>
                      <p className="text-zinc-600 text-[10px] mt-0.5">{n.time}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="px-4 py-2.5 border-t border-zinc-800">
                <button className="text-orange-400 text-xs font-medium w-full text-center cursor-pointer hover:text-orange-300 transition-colors">
                  Zobraziť všetky
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Admin avatar */}
        <div className="w-9 h-9 bg-orange-500 rounded-xl flex items-center justify-center cursor-pointer hover:bg-orange-600 transition-all">
          <span className="text-white text-sm font-bold">MB</span>
        </div>
      </div>
    </header>
  );
}
